import _ColorPicker from './ColorPicker';
import './style';

export type { ColorPickerProps } from './ColorPicker';
export * from './type';

export const ColorPicker = _ColorPicker;
export default ColorPicker;
